'use strict';

module.exports = {
  Timeline: require('./Timeline').default, // eslint-disable-line global-require
  TimelineItem: require('./TimelineItem').default // eslint-disable-line global-require
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vertical-timeline-component-for-react/dist/index.js
// module id = 1578
// module chunks = 0